import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
//@ts-ignore
import { ITicketParameter, TicketParameter, ITicketListingViewModel } from '@/models/ticket';
//@ts-ignore
import { StateTypes, ActivityStatus } from '@/common/enums';
import { namespace } from 'vuex-class';
//@ts-ignore
import { TICKET_MODULE_NAMESPACE, } from '@/store/ticket';
//@ts-ignore
import { BLOCK_MODULE_NAMESPACE, BLOCK_APARTMENT_SIDEBAR_GET_TICKETS } from '@/store/block';

const TicketStore = namespace(TICKET_MODULE_NAMESPACE)
const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)

@Component({
  components: {
    'list-item': async () => import('@/containers/ticket/components/ticket-list-item/TicketListItem.vue'),
    'ticket-modal': async () => import('@/containers/ticket/components/ticket-modal-vertical/TicketModalVertical.vue'),
    'no-record': async () => import('@/components/empty/Empty.vue')
  }
})
class BlockApartmentsTickets extends Vue {

  dtAcitivityStatus: ActivityStatus
  dtCreateAnother: boolean;
  dtIsRecording: boolean;
  dtTicketModalVisible: boolean;
  dtAttachments: any[];
  _clearTimeout: any;
  @Prop({ default: () => new TicketParameter({ state: [StateTypes.InProgress] }) })
  parameter: ITicketParameter;

  @BlockStore.Getter currentBlockId: number;
  @BlockStore.Getter blockApartmentInProcessTickets: ITicketListingViewModel[];


  @BlockStore.Action(BLOCK_APARTMENT_SIDEBAR_GET_TICKETS)
  storeGetTickets: (payload: {
    ticketParameter: ITicketParameter,
    storeKey?: string
  }) => Promise<ITicketListingViewModel[]>


  dtTicketParameter: ITicketParameter;
  /**
   *
   */
  constructor() {
    super();
    this.dtCreateAnother = false;
    this.dtIsRecording = false;
    this.dtTicketModalVisible = false;
    this.dtAttachments = [];
    this.dtAcitivityStatus = ActivityStatus.NoActivity;
  }

  get lblSetting(): { [prop: string]: string } {
    return {
      ...require('@/locales/block').default,
      ...require('@/locales/ticket').default
    }
  }

  get blockId(): number[] {
    return [parseInt(this.$route.params.id)]
  }

  get apartmentId(): number {
    return parseInt(this.$route.params.cid);
  }
  get ticketPameter(): ITicketParameter {
    return new TicketParameter({
      state: [StateTypes.InProgress, StateTypes.Open, StateTypes.ReOpen],
      block: [parseInt(this.$route.params.id)],
      apartment: parseInt(this.$route.params.cid)
    })
  }
  get isLoading(): boolean {
    return this.dtAcitivityStatus === ActivityStatus.Loading;
  }
  mounted() {
    this.$watch('$route.params', this.handleChangeRoute)
    this.handleLoadTickets();
  }
  handleChangeRoute(newCid: string, oldCid: string) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => this.handleLoadTickets(), 300);
  }
  private async handleLoadTickets() {
    this.dtAcitivityStatus = ActivityStatus.Loading;
    this.storeGetTickets({
      ticketParameter: this.ticketPameter,
      storeKey: 'blockApartmentInProcessTickets'
    })
      .then(response => {
        this.dtAcitivityStatus = ActivityStatus.Loaded;
      })
      .catch(err => {
        this.dtAcitivityStatus = ActivityStatus.LoadFailed;
      })
  }
  get maxWidth(): string {
    return `${document.body.clientWidth * 0.60}px`
  }
  handleCreateTicket() {
    this.dtTicketModalVisible = true;
  }
  handleSave() {
    console.log('handleSave')
  }
  handleBeforeModalClose() {
    console.log('handleBeforeModalClose')

  }
}

export default BlockApartmentsTickets;


// WEBPACK FOOTER //
// ./src/containers/block/components/block-apartment-tickets/index.ts